import './my-selections.css';

import { useState, useMemo } from 'react';
import { History } from 'lucide-react';
import { useLeague, useUserWallets } from '../../../hooks';

type Mode = 'main' | 'arena';

interface Props {
  mode: Mode;
}

const MySelections = ({ mode }: Props) => {
  const { currentSeason, league } = useLeague();
  const { wallets } = useUserWallets();

  const [showMySelections, setShowMySelections] = useState(false);

  const selectedTokens = useMemo(() => {
    if (!league?.id || !currentSeason?.seasonNumber) return [];

    const wallet = wallets.find(
      (w) =>
        w.leagueId === league.id &&
        w.seasonId === currentSeason.seasonNumber &&
        w.type === mode,
    );

    return wallet?.claimed ?? [];
  }, [wallets, league, currentSeason, mode]);

  return (
    <>
      <button
        onClick={() => setShowMySelections((v) => !v)}
        className="isg-league-button"
        style={{
          backgroundColor: currentSeason?.bgColor,
          color: currentSeason?.color,
        }}
      >
        <History className="isg-league-button-icon" />
        {showMySelections ? 'Ocultar' : 'Ver'} Mis Selecciones
      </button>

      {showMySelections && (
        <div
          className="isg-league-selections-box"
          style={{
            borderColor: currentSeason?.bgColor,
            background: `${currentSeason?.bgColor}10`,
          }}
        >
          <h3
            className="isg-league-selections-title"
            style={{ color: currentSeason?.color }}
          >
            Tokens seleccionados
          </h3>

          {selectedTokens.length === 0 ? (
            <p className="isg-league-empty">
              Aún no has seleccionado ningún token
            </p>
          ) : (
            <div className="isg-league-tokens">
              {selectedTokens.map((token) => (
                <span
                  key={token}
                  className="isg-league-token"
                  style={{
                    backgroundColor: currentSeason?.bgColor,
                    color: currentSeason?.color,
                  }}
                >
                  #{token}
                </span>
              ))}
            </div>
          )}
        </div>
      )}
    </>
  );
};

export default MySelections;
